import React from "react";
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Divider, Form, Input, Space} from 'antd';
import "./my-list-component.scss";


const { TextArea } = Input;

const MyListComponent = () => {

    const onFinish = (values) => {
        console.log('Received values of form:', values);
    };

    const onChange = (e) => {
        console.log('Change:', e.target.value);
    };

    return (
        <>
            <Form name="dynamic_form_nest_item" onFinish={onFinish} autoComplete="off">
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    <div style={{margin: '0 20px 10px 0'}}>
                        <Divider orientation="left">1 квартал</Divider>
                        <div className="work-list">
                            <Form.List name="task1">
                                {(fields, {add, remove}) => (
                                    <>
                                        {fields.map(({key, name, ...restField}) => (
                                            <Space
                                                key={key}
                                                style={{
                                                    display: 'flex',
                                                }}
                                                align="baseline"
                                            >
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'task1']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Пропустили текст',
                                                        },
                                                    ]}
                                                >
                                                    <TextArea
                                                        style={{
                                                            height: 70,
                                                            width: 350
                                                        }}
                                                        onChange={onChange}
                                                    />
                                                </Form.Item>
                                                <MinusCircleOutlined onClick={() => remove(name)}/>
                                            </Space>
                                        ))}
                                        <Form.Item>
                                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                                Добавить
                                            </Button>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                        </div>
                    </div>
                    <div style={{margin: '0 20px 10px 0'}}>
                        <Divider orientation="left">2 квартал</Divider>
                        <div className="work-list">
                            <Form.List name="task2">
                                {(fields, {add, remove}) => (
                                    <>
                                        {fields.map(({key, name, ...restField}) => (
                                            <Space
                                                key={key}
                                                style={{
                                                    display: 'flex',
                                                }}
                                                align="baseline"
                                            >
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'task2']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Пропустили текст',
                                                        },
                                                    ]}
                                                >
                                                    <TextArea
                                                        style={{
                                                            height: 70,
                                                            width: 350
                                                        }}
                                                        onChange={onChange}
                                                    />
                                                </Form.Item>
                                                <MinusCircleOutlined onClick={() => remove(name)}/>
                                            </Space>
                                        ))}
                                        <Form.Item>
                                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                                Добавить
                                            </Button>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                        </div>
                    </div>
                    <div style={{margin: '0 20px 10px 0'}}>
                        <Divider orientation="left">3 квартал</Divider>
                        <div className="work-list">
                            <Form.List name="task3">
                                {(fields, {add, remove}) => (
                                    <>
                                        {fields.map(({key, name, ...restField}) => (
                                            <Space
                                                key={key}
                                                style={{
                                                    display: 'flex',
                                                }}
                                                align="baseline"
                                            >
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'task3']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Пропустили текст',
                                                        },
                                                    ]}
                                                >
                                                    <TextArea
                                                        style={{
                                                            height: 70,
                                                            width: 350
                                                        }}
                                                        onChange={onChange}
                                                    />
                                                </Form.Item>
                                                <MinusCircleOutlined onClick={() => remove(name)}/>
                                            </Space>
                                        ))}
                                        <Form.Item>
                                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                                Добавить
                                            </Button>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                        </div>
                    </div>
                    <div style={{margin: '0 20px 10px 0'}}>
                        <Divider orientation="left">4 квартал</Divider>
                        <div className="work-list">
                            <Form.List name="task4">
                                {(fields, {add, remove}) => (
                                    <>
                                        {fields.map(({key, name, ...restField}) => (
                                            <Space
                                                key={key}
                                                style={{
                                                    display: 'flex',
                                                }}
                                                align="baseline"
                                            >
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'task4']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Пропустили текст',
                                                        },
                                                    ]}
                                                >
                                                    <TextArea
                                                        style={{
                                                            height: 70,
                                                            width: 350
                                                        }}
                                                        onChange={onChange}
                                                    />
                                                </Form.Item>
                                                <MinusCircleOutlined onClick={() => remove(name)}/>
                                            </Space>
                                        ))}
                                        <Form.Item>
                                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                                Добавить
                                            </Button>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                        </div>
                    </div>
                </div>
                <Form.Item className="save-work-list">
                    <Button type="primary" htmlType="submit">
                        Сохранить
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}

export default MyListComponent;
